var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-handshake"
  }), _c('h3', {
    staticClass: "join-complete__title"
  }, [_vm._v("회원가입이 완료 되었습니다.")]), _c('p', {
    staticClass: "join-complete__text mt-8 mt-md-14 text-center"
  }, [_vm._v(" 관리자 승인 후 기업서비스를 이용하실 수 있습니다"), _c('br'), _vm._v(" 1~2 영업일 이내에 승인여부를 확인 하실 수 있습니다 ")])]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "tile": "",
      "block": "",
      "color": "primary lighten-4"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" 이전 화면으로 돌아가기 ")])], 1), _c('v-col', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "tile": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('next');
      }
    }
  }, [_vm._v(" 대시보드로 가기 ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }